import { Helmet } from "react-helmet-async";
import UserGuide from "../components/userguide/UserGuide";

/**
 * @author sukim91
 * @date 2022-09-28 15:18:22
 * @remark 가이드 페이지 스크린
 * @param props None
 * @returns <UserGuide>
 */
function UserGuideScreen() {
    /** 페이지 스크롤 가장 상단의 컨테이너로 이동 */
    // useEffect(() => {
    //     document.getElementById("user_guide")!.scrollIntoView({ behavior: "smooth" });
    // }, []);

    return (
        <>
            <Helmet>
                <title>가이드 - 모두의지도</title>
                <meta property="og:type" content="website" />
                <meta name="title" property="og:title" content="가이드 - 모두의지도" />
                <meta name="description" property="og:description" content="모두의지도 사용법을 친절히 안내해드립니다." />
                <meta name="imgage" property="og:image" content="https://modoomap.com/createMap.jpg" />
                <meta name="url" property="og:url" content="https://modoomap.com/features" />
            </Helmet>
            <UserGuide />
        </>
    );
}

export default UserGuideScreen;
